export default __webpack_public_path__ + "static/recipes-0ef15b7fa84eb247cb3c51a8a03ec8e6.webm";